import { createReducer, on } from '@ngrx/store';
import { ToolActions } from '@store/actions/tool.actions';
import { ToolState, defaultToolState } from '@models/tool.model';

export const toolReducer = createReducer(
  defaultToolState,
  on(ToolActions.selectTool,     (s, { tool })  => ({ ...s, activeTool: tool })),
  on(ToolActions.setActiveColor, (s, { color }) => ({ ...s, activeColor: color })),
  on(ToolActions.addRecentColor, (s, { color }) => ({
    ...s, recentColors: [color, ...s.recentColors.filter(c => c !== color)].slice(0, 12)
  })),
  on(ToolActions.setBrushSize,  (s, { size })   => ({ ...s, brushSize: size })),
  on(ToolActions.setSymmetry,   (s, { mode })   => ({ ...s, symmetryMode: mode })),
  on(ToolActions.setShapeFill,  (s, { mode })   => ({ ...s, shapeFillMode: mode })),
);
